import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-op-exitosa-modal',
  imports: [],
  templateUrl: './op-exitosa-modal.component.html',
  styleUrl: './op-exitosa-modal.component.css',
  standalone: false
})
export class OpExitosaModalComponent {
  
  constructor(private dialogRef: MatDialogRef<OpExitosaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  cerrarModal() {
    this.dialogRef.close();
  }
}
